import React, { Component } from 'react';
import {Form, Control, Fieldset} from 'react-redux-form';
import _ from "lodash";
import {toInt} from "../parsers";
import {formatMoney} from "accounting-js";
import {confirmAlert} from "react-confirm-alert";

export default class ProjectExpensesEditForm extends Component{
	render(){
		const {projects} = this.props;
		let pc = _.find(projects.permissions, (o) => {return o==='Create'});
		let totalExpenses = 0;
		_.map(projects.expenses, (o) => totalExpenses += o.total);
		return(
			<Form model="projects.expenses" onSubmit={(values) => this._submitForm(values)} onSubmitFailed={() => this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger')}>
				{this.state.expenseEditShow ? <ExpenseEditModal expenseIndex={this.state.expenseIndex} active={this.state.expenseEditShow} closeModal={() => this._toggleModal()} {...this.props}/> : ''}
				{pc &&
				<div className="field is-grouped is-grouped-right">
					<div className="control">
						<button type="button" className="button is-primary" onClick={() => this._addExpense()}>
					        <span className="icon">
					            <i className="fa fa-plus" />
					        </span>
							<span>Agregar gasto</span>
						</button>
					</div>
				</div>}

				<table className="inm-table">
					<thead>
					<tr>
						<th>No.</th>
						<th>Concepto del gasto</th>
						<th>Unidad de medida</th>
						<th>Cantidad</th>
						<th className="has-text-right">Valor</th>
						<th className="has-text-right">Total</th>
					</tr>
					</thead>
					<tbody>
					{!_.isEmpty(projects.expenses) ?
						_.map(projects.expenses, (row, k) => {
							return (
								<tr key={`expenses-table-row-${k}`}>
									<td>
										<div className="actions">
											<button type="button" style={{cursor: 'pointer'}} onClick={() => this._editExpense(k, row)}><i className="fa fa-edit" /></button>
											<button type="button" style={{cursor: 'pointer'}} onClick={() => this._removeExpense(k)}><i className="fa fa-trash-o" /></button>
										</div>
										{k+1}
									</td>
									<td>{row.expense_concept.name}</td>
									<td>{row.expense_unit.name}</td>
									<td>{row.quantity}</td>
									<td className="has-text-right">{formatMoney(row.amount)}</td>
									<td className="has-text-right">{formatMoney(row.total)}</td>
								</tr>
							)
						})
						:<tr>
							<td colSpan="7" className="has-text-center">
								<h2>No hay gastos registrados</h2>
							</td>
						</tr>}
					</tbody>
					<tfoot>
					<tr>
						<td colSpan="5" className="has-text-right"><strong>Total</strong></td>
						<td colSpan="2" className="has-text-right"><strong>{formatMoney(totalExpenses)}</strong></td>
					</tr>
					</tfoot>
				</table>

				<div className="field is-grouped is-grouped-right">
					<div className="control">
						<button type="button" className="button is-large" onClick={() => this.props.history.push(`/proyectos`)}>Regresar</button>
					</div>
					<div className="control">
						<Control.button model="projects.expenses" className="button is-large is-inm-purple" type="submit" disabled={this._validateSave()}>Guardar</Control.button>
					</div>
				</div>
			</Form>
		)
	}

	constructor(){
		super();
		this.state = {
			expenseIndex: undefined,
			expenseEditShow: false
		}

	}

	_submitForm(values) {
		//console.log('values: ',values);
		this.props.projectsExpensesSave(this.props.match.params.id, values);
	}

	_editExpense(expenseIndex,row){
		this.props.change(`projects.edit`,{
			temp_expense_concept_id: row.expense_concept_id,
			temp_expense_unit_id: row.expense_unit_id,
			temp_quantity: row.quantity,
			temp_amount: row.amount,
		});

		this.setState({
			expenseIndex: expenseIndex,
			expenseEditShow: true
		})
	}

	_addExpense(){
		this.setState({
			expenseEditShow: true
		})
	}

	_removeExpense(expenseIndex) {
		confirmAlert({
			title: '¿Esta seguro?',
			message: '¿Estás seguro/(a) de eliminar el gasto?',
			confirmLabel: 'Eliminar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.remove('projects.expenses',expenseIndex)
		});
	}

	_toggleModal() {
		this.setState({
			expenseIndex: undefined,
			expenseEditShow: false
		});

		this.props.change(`projects.edit`,{});
	}

	_validateSave(){
		const {projects} = this.props;
		let pc = _.find(projects.permissions, (o) => {return o==='Create'});
		let pu = _.find(projects.permissions, (o) => {return o==='Update'});

		if(pu || pc){
			return false;
		}else {
			return true;
		}
	}
}

class ExpenseEditModal extends Component{
	render(){
		let {projects, concepts} = this.props;
		let conceptData = _.find(concepts.list,{id: projects.edit.temp_expense_concept_id});
		let unitslist = conceptData ? conceptData.units:[];
		return(
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-card">
					<header className="modal-card-head">
						<p className="modal-card-title">Gasto de coordinación</p>
						<button type="button" onClick={this.props.closeModal} className="delete"
						        aria-label="close"></button>
					</header>
					<div className="modal-card-body">
						<Fieldset model={`projects.edit`}>
							<div className="field">
								<div className="control">
									<label htmlFor="temp_expense_concept_id" className="label">Concepto <span className="small has-text-danger">*</span></label>
									<div className="select">
										<Control.select id="temp_expense_concept_id" model=".temp_expense_concept_id" parser={ toInt } changeAction={(model,value) => this._changeConcept(model,value)}>
											<option value="">--- Concepto ---</option>
											{_.map(concepts.list,(st, k) => {
												return <option value={st.id} key={k}>{st.name}</option>
											})}
										</Control.select>
									</div>

								</div>
							</div>
							<div className="field">
								<div className="control">
									<label htmlFor="temp_expense_unit_id" className="label">Unidad de medida <span className="small has-text-danger">*</span></label>
									<div className={`select`}>
										<Control.select id="temp_expense_unit_id" model=".temp_expense_unit_id" parser={ toInt }>
											<option value="">--- Unidad de medida ---</option>
											{_.map(unitslist,(st, k) => {
												return <option value={st.id} key={k}>{st.name}</option>
											})}
										</Control.select>
									</div>
								</div>
							</div>
							<div className="field is-grouped">
								<div className="control">
									<label htmlFor="temp_quantity" className="label">Cantidad <span className="small has-text-danger">*</span></label>
									<Control.text type="number" min="0" model=".temp_quantity" id="temp_quantity" className="input"/>
								</div>
								<div className="control">
									<label htmlFor="temp_amount" className="label">Gasto <span className="small has-text-danger">*</span></label>
									<Control.text model=".temp_amount" className="input" id="temp_expense" type="number" step="0.01" min="0"  placeholder="$"/>
								</div>
							</div>
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button type="button" className="button" onClick={this.props.closeModal}>Cerrar</button>
								</div>
								<div className="control">
									<button type="button" className="button is-primary" onClick={() => this._saveExpense()} disabled={this._getValidate(projects.edit.temp_expense_unit_id)}>Guardar</button>
								</div>
							</div>
							<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
						</Fieldset>
					</div>
				</div>
			</div>
		)
	}

	_saveExpense(){
		let {expenseIndex, projects, concepts} = this.props;
		let {edit} = projects;

		if(edit.temp_expense_concept_id &&
			edit.temp_expense_unit_id &&
			edit.temp_quantity &&
			edit.temp_amount){
			let total = _.toNumber(edit.temp_quantity) * _.toNumber(edit.temp_amount);
			let conceptData = _.find(concepts.list, {id: edit.temp_expense_concept_id});
			let unitData = _.find(conceptData.units, {id: edit.temp_expense_unit_id});

			if(_.isNumber(expenseIndex) && projects.expenses[expenseIndex].id){
				this.props.change(`projects.expenses[${expenseIndex}]`,{
					...projects.expenses[expenseIndex],
					expense_concept_id: edit.temp_expense_concept_id,
					expense_unit_id: edit.temp_expense_unit_id,
					quantity: edit.temp_quantity,
					amount: edit.temp_amount,
					total: total,
					expense_concept: {
						name: conceptData.name
					},
					expense_unit: {
						name: unitData.name
					}
				});
			}else {
				this.props.add(`projects.expenses`,{
					expense_concept_id: edit.temp_expense_concept_id,
					expense_unit_id: edit.temp_expense_unit_id,
					quantity: edit.temp_quantity,
					amount: edit.temp_amount,
					total: total,
					expense_concept: {
						name: conceptData ? conceptData.name:''
					},
					expense_unit: {
						name: unitData ? unitData.name:''
					}
				});
			}

			this.props.closeModal();
		}else {
			alert('Hay errores en el formulario');
		}

	}

	_changeConcept(model,value){
		this.props.change(model,value);
		this.props.change('projects.edit.temp_expense_unit_id',undefined);
	}

	_getValidate(id){
		let { projects, expenseIndex } = this.props;
		let { expenses } = projects;
		let unit = _.find(expenses,{expense_unit_id: id})

		if(expenseIndex !== undefined && expenseIndex !== '' && expenseIndex !== null){
			if(projects.expenses[expenseIndex].expense_unit_id === id){
				return false;
			}else if(_.isEmpty(unit)){
				return false;
			}else {
				return true;
			}
		}else {
			if(_.isEmpty(unit)){
				return false;
			}else {
				return true;
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/elements/projects/expenses.jsx